<div class="topdiv" >



    <div class="row topRowMargins headerStyle" style="margin-top: 0;">
      <div  style="margin-left: 15px;">
        <label class="textColour">Headers List</label>
      </div>
    </div>
    <div class="container" *ngIf="!showTargetFieldOnly">
        <div class="row" *ngIf="headersDataList.length > 0" style="margin-top:
                  -15px;">
          <div class="table-responsive" >
            <table class="table" style="margin-bottom: 0;">
              <caption></caption>
              <thead class="table-heading">
                <!-- style="position: sticky;z-index: 2;top: 0; max-height: 150px;overflow-y: auto;" -->
                <tr>
                  <th class="th-lg text-left">Source / Target</th>
                  <th class="th-lg text-left">Header Name</th>
                  <th class="th-lg text-left">Data Type</th>
                  <th class="th-lg text-left">Key Order</th>
                  <th class="th-lg text-left">Is Mandatory</th>
                  <th class="th-lg text-left" style="text-align: end; padding-right: 33px;">Action</th>
                </tr>
              </thead>
              <tbody style="border:none;" >
                <tr *ngFor="let whereData of headersDataList; let k= index;" cdkDrag>
                  <td class="conditionsalign text-left">{{whereData.sourceOrTarget}}</td>
                  <td class="conditionsalign text-left">{{whereData.label}}</td>
                  <td class="conditionsalign text-left">{{whereData.datatype}}</td>
                  <td class="conditionsalign text-left">{{whereData.keyOrder}}</td>
                  <td class="conditionsalign text-left">
                    <span *ngIf="whereData.isMandatory">Yes</span>
                    <span *ngIf="!whereData.isMandatory">No</span>
                  </td>
                  <td class="conditionsalign text-left" style="text-align: end; padding-right: 33px;">
                    <!-- <label class="CloseButtonStyle">
                      <span><em (click)="deleteWhere(k)" class="fas fa-minus" style="color: white;"
                          title="Remove Filter"></em></span>
                    </label> -->
                    <button title="Edit" (click)="editHeader(whereData,k);" [disabled]="isDefaultHeader(whereData.label)" class="btn btn-outline btn-primary btn-rounded btn-sm waves-effect waves-light" style="padding: .3rem .8rem;margin-top:0rem" id="115">
                      <i class="fas fa-pencil-alt"></i>
                    </button>
                    <button title="Delete" (click)="deleteWhere(k);" [disabled]="isDefaultHeader(whereData.label)" class="btn btn-outline btn-rounded btn-sm waves-effect waves-light"  style="padding: .3rem .8rem;margin-top:0rem;background:#d71920">
                      <i class="far fa-trash-alt"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

      </div>
      <div *ngIf="showTargetFieldOnly">
        <form novalidate [formGroup]='target_header_validations_form'> 
            <div class="row">
                <div class="col-lg-4" style="
                  text-align: end">
                    <mat-form-field class="filter" appearance="outline">
                      <mat-label i18n="@@targetloginusername">
                         Select Target Headers
                      </mat-label>
                      <mat-select formControlName="targetHeaderList" [(ngModel)]="targetHeaderList" (selectionChange)="selectedTargetList($event)" multiple>
                              <mat-option *ngFor="let tempObject of editHeadersListData" [value]="tempObject">
                                  {{tempObject}}
                              </mat-option>
                      </mat-select>
                  </mat-form-field>
                  </div>
                  </div>
                  </form>
                  </div>
    <div *ngIf="!showTargetFieldOnly">
        <form novalidate [formGroup]='validations_form'> 
            <div class="row">
                <div class="col-lg-3" style="
                  text-align: end">
                    <mat-form-field class="filter" appearance="outline">
                        <mat-label i18n="@@targetloginusername">
                            Source / Target
                        </mat-label>
                        <mat-select formControlName="sourceOrTarget" [(ngModel)]="headersObjects.sourceOrTarget" (selectionChange)="onSourceOrTarget($event)">
                                <mat-option *ngFor="let tempObject of sourceOrTargetTypeData" [value]="tempObject.type">
                                    {{tempObject.type}}
                                </mat-option>
                        </mat-select>
                        <mat-error *ngFor="let validation of validation_messages.sourceOrTarget">
                          <span
                            *ngIf="validations_form.get('sourceOrTarget').hasError(validation.type) && (validations_form.get('sourceOrTarget').dirty || validations_form.get('sourceOrTarget').touched)">
                            {{ validation.message }}
                          </span>
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-lg-3" style="
                  text-align: end">
                  <mat-form-field appearance="outline">
                    <mat-label i18n="@@TMSTAFFMASTERfirstname">Header Name</mat-label>
                    <input matInput type="text" placeholder="Header Name" formControlName="headerName"
                      [(ngModel)]="headersObjects.label" maxlength="100" required>
                    <mat-error *ngFor="let validation of validation_messages.headerName">
                      <span
                        *ngIf="validations_form.get('headerName').hasError(validation.type) && (validations_form.get('headerName').dirty || validations_form.get('headerName').touched)">
                        {{ validation.message }}
                      </span>
                    </mat-error>
                  </mat-form-field>
                </div> 
                <div class="col-lg-3" style="
            text-align: end">
              
                  <mat-form-field class="filter" appearance="outline">
                      <mat-label i18n="@@targetloginusername">
                          Data Type
                      </mat-label>
                      <mat-select formControlName="dataType" [(ngModel)]="headersObjects.datatype" (selectionChange)="onSourceOrTarget($event)">
                              <mat-option *ngFor="let tempObject of datatypeList" [value]="tempObject">
                                  {{tempObject}}
                              </mat-option>
                      </mat-select>
                      <mat-error *ngFor="let validation of validation_messages.dataType">
                        <span
                          *ngIf="validations_form.get('dataType').hasError(validation.type) && (validations_form.get('dataType').dirty || validations_form.get('dataType').touched)">
                          {{ validation.message }}
                        </span>
                      </mat-error>
                  </mat-form-field>
              </div>
              <div class="col-lg-3" style="
              text-align: end">
              <mat-form-field appearance="outline">
                <mat-label i18n="@@TMSTAFFMASTERfirstname">Key Order</mat-label>
                <input matInput type="text" placeholder="Key Order" formControlName="keyOrder"
                  [(ngModel)]="headersObjects.keyOrder" maxlength="100" required>
                <mat-error *ngFor="let validation of validation_messages.keyOrder">
                  <span
                    *ngIf="validations_form.get('keyOrder').hasError(validation.type) && (validations_form.get('keyOrder').dirty || validations_form.get('keyOrder').touched)">
                    {{ validation.message }}
                  </span>
                </mat-error>
              </mat-form-field>
            </div> 
            <div class="col-lg-3" >
              <mat-checkbox class="example-margin"
              [(ngModel)]="headersObjects.isMandatory"
              formControlName="isMandatory"
              >Is Mandatory</mat-checkbox>
              <!-- <mat-error *ngFor="let validation of validation_messages.filtername">
                <span
                  *ngIf="validations_form.get('filtername').hasError(validation.type) && (validations_form.get('filtername').dirty || validations_form.get('filtername').touched)">
                  {{ validation.message }}
                </span>
              </mat-error> -->
          </div> 
          <div class="col-lg-3" >
            <div style="width: 15%;">
              <label (click)="addWhere()" style="margin-top: 6px;
                background: green;
                margin-bottom: auto;
                padding: 2px 5px 0px 5px;
                border-radius: 15px;"><em class="fas fa-plus" style="color:
                  antiquewhite;font-size: large;" title="Add Header"></em></label>
            </div>
            </div>
                </div>
            </form>

    </div>
    <div class="col-lg">
        <div class="container" style="text-align: center; margin-left: 25px;">
          <div class="row topRowMargins">
            <div class="col-lg-3"></div>
            <div class="col-lg-5">
            </div>
            <div class="col-lg-2" *ngIf="showTargetFieldOnly">
              <button i18n="@@TMRunButton" type="button" (click)="saveEditHeaders()" [style.background-color]="buttonColor"
                class="actionButton btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
                style="padding: .3rem 1.5rem;font-size: .85rem;width:100%;">Add</button>
            </div>
            <div class="col-lg-2" *ngIf="!showTargetFieldOnly">
              <button i18n="@@TMRunButton" type="button" (click)="saveHeaders()" [style.background-color]="buttonColor"
                class="actionButton btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
                style="padding: .3rem 1.5rem;font-size: .85rem;width:100%;">Add</button>
            </div>
            <div class="col-lg-2">
              <button i18n="@@TMRunButton" type="button" (click)="cancel()" [style.border-color]="buttonColor"
                class="cancelButton btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
                style="padding: .3rem 1.6rem;font-size: .85rem;width:100%;">Cancel</button>
            </div>
    
          </div>
        </div>
      </div>
    </div>
